/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 *
 * Config-driven Explore filter sidebar. Renders the filter groups a product
 * exposes (per GROUP_PRODUCT_TAGS) using the presentation defined in
 * GROUP_LAYOUT. Replaces the previously duplicated per-universe components so
 * contractor/business (and future products) share one rendering path.
 */

import React from "react";

import { getGroupKeysForProduct } from "../../../common/metadata/FilterConfig";
import { useUniverseFilter } from "./hook/useUniverseFilter";
import { GROUP_LAYOUT, universeKeyToProductKey } from "./productFilterLayout";
import FilterSection from "./components/FilterSection";
import MultiSubgroupFilterSection from "./components/MultiSubgroupFilterSection";

const APPEARANCE = 'card';

const UniverseFilter = ({ universeKey, searchText }) => {
    const { commonProps } = useUniverseFilter(universeKey, searchText);

    const productKey = universeKeyToProductKey(universeKey);
    const allowedGroups = getGroupKeysForProduct(productKey);
    const layout = GROUP_LAYOUT.filter(g => allowedGroups.has(g.key));

    return (
        <>
            {layout.map(group => (
                group.section === 'multi' ? (
                    <MultiSubgroupFilterSection
                        key={group.key}
                        groupKey={group.key}
                        title={group.title}
                        subTitle={group.subTitle}
                        appearance={APPEARANCE}
                        defaultMainOpen={group.defaultMainOpen}
                        subGroups={group.subGroups}
                        productKey={productKey}
                        {...commonProps}
                    />
                ) : (
                    <FilterSection
                        key={group.key}
                        groupKey={group.key}
                        title={group.title}
                        subTitle={group.subTitle}
                        appearance={APPEARANCE}
                        defaultOpen={group.defaultOpen}
                        productKey={productKey}
                        {...commonProps}
                    />
                )
            ))}
        </>
    );
};

export default UniverseFilter;
